module.exports = __webpack_public_path__ + "static/media/greentick.85e81990.svg";